import React from "react";

const COVER = "/logos/login-cover-clean.webp";

function startGoogle() {
  const here = window.location.pathname;
  if (here && here !== "/") sessionStorage.setItem("vikas_after_login", here);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

function GoogleMark() {
  return (
    <svg viewBox="0 0 18 18" width="18" height="18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.97 10.72A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.95H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.05l3.01-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}

function SignInCard({ error, busy }) {
  return (
    <div className="gate-card" data-testid="gate-card">
      <div className="gate-eyebrow">VIKAS</div>
      <h1 className="gate-title" data-testid="gate-title">Dashboard</h1>
      <button type="button" className="gate-google" data-testid="gate-google" disabled={busy} onClick={startGoogle}>
        <GoogleMark /> {busy ? "Signing in…" : "Sign in with Google"}
      </button>
      {error && <div className="gate-error" role="alert" data-testid="gate-error">{error}</div>}
      <div className="gate-foot" data-testid="gate-outgoing">Prepared by VIKAS, our proprietary intelligence system</div>
    </div>
  );
}

export function Gate({ error, busy }) {
  return (
    <div className="gate-cover" data-testid="gate-cover">
      <div className="gate-band" style={{ backgroundImage: `url(${COVER})` }} aria-hidden="true" />
      <div className="gate-stage">
        <img src={COVER} alt="Renevik Solar — powered by Vikas Arya Group" className="gate-img" data-testid="gate-image" />
        <SignInCard error={error} busy={busy} />
      </div>
    </div>
  );
}
